import { FAQPageSchema } from '@/components/feature/SchemaOrg';

export default function FAQSection() {
  const faqs = [
    {
      question: '嫩草视频需要付费吗？',
      answer: '不需要！嫩草视频聚合妖精视频、桃花视频等平台资源，所有内容完全免费在线观看。无需购买会员，即可畅享全网热播影视剧、电影大全高清资源。',
    },
    {
      question: '嫩草视频支持哪些设备观看？',
      answer: '嫩草视频支持手机、平板、电脑等多终端在线观看，兼容主流浏览器。无论你在哪里，都能随时追剧看电影。',
    },
    {
      question: '影视剧更新速度快吗？',
      answer: '非常快！嫩草视频与妖精视频、桃花视频、苹果视频、榴莲视频等平台同步更新，热播剧每日更新最新剧集，电影第一时间上线，追剧不等待。',
    },
    {
      question: '视频画质怎么样？卡不卡？',
      answer: '嫩草视频提供高清在线观看体验，支持1080P超清画质。采用先进的视频加速技术，播放流畅不卡顿。',
    },
    {
      question: '有没有广告？',
      answer: '嫩草视频致力于为用户提供清爽的观影体验，广告数量极少且不影响观影。我们持续优化用户体验。',
    },
    {
      question: '可以下载离线观看吗？',
      answer: '嫩草视频为在线视频聚合平台，提供高清在线观看服务。部分合作平台支持缓存功能，具体以各平台规则为准。',
    },
  ];

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <FAQPageSchema questions={faqs} />
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">常见问题</h2>
          <p className="text-foreground-600 text-sm">关于嫩草视频的常见疑问解答</p>
        </div>
        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <details key={i} className="group rounded-lg bg-background-50 border border-background-200/70 overflow-hidden">
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer text-sm font-medium text-foreground-900">
                {faq.question}
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-arrow-down-s-line group-open:rotate-180 transition-transform text-foreground-500"></i>
                </div>
              </summary>
              <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                {faq.answer}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}